export default "__VITE_ASSET__DuCGU81$__"